import { useMemo } from "react"
import { useGetClientMyPlacesTrendQuery } from "../generated/graphql"
import { buildMyPlacesTrendData } from "../utils/myPlacesTrend"
import { useGraphQLClient } from "./useGraphQLClient"

/**
 * Fetches a client's place visits and shapes the most recent fourteen local
 * calendar days for the My Places chart.
 */
export function useMyPlacesTrend(clientId: string, viraPathEnabled: boolean) {
  const graphQLClient = useGraphQLClient()
  const query = useGetClientMyPlacesTrendQuery(
    graphQLClient,
    { clientId },
    { enabled: Boolean(clientId) && Boolean(viraPathEnabled) }
  )
  const chartData = useMemo(
    () =>
      buildMyPlacesTrendData(query.data?.relapse_prevention_place_visits ?? []),
    [query.data?.relapse_prevention_place_visits]
  )

  return {
    data: chartData,
    isError: query.isError,
    isLoading: query.isLoading,
  }
}
